var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        { style: { flexGrow: 1 }, attrs: { center: "" } },
        [
          _c("w-col", { attrs: { xs: "12", center: "" } }, [
            _c(
              "div",
              { staticClass: "progress-container" },
              [
                _c("span", { staticClass: "progress-text" }, [
                  _vm._v(_vm._s(_vm.$t("views.InitDossierProgress.preparing"))),
                ]),
                _c("w-progress-linear", { attrs: { large: "", value: null } }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }